export default {
	'add-new-category': '',
	category: '',
	'the-category': ''
}